import { colors } from "widgets/utils";

import { GROUP_HEADER_HEIGHT, syntenyViewerDefaultTracks } from "../../settings.ts";
import { useGenomeViewerStore } from "../../store/store.ts";
import type { Track } from "../../types.ts";

/**
 * This draw the track header title
 * Always aligned on the left side of the main canvas. Not shifted.
 */
export function drawTracksHeader(tracks: Track[]) {
  const { ctx, hoveredTackId } = useGenomeViewerStore.getState();
  let currentY = GROUP_HEADER_HEIGHT;

  if (!ctx) return;

  const FONT_SIZE = 11;
  const PADDING_HORIZONTAL = 5;
  const PADDING_VERTICAL = 3;
  const MARGIN = 2;
  const CORNER_RADIUS = 3;

  ctx.save();

  ctx.font = `${FONT_SIZE}px Roboto Flex`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";

  for (const { trackType, subType, height, trackId } of tracks) {
    const label =
      syntenyViewerDefaultTracks.find((t) => t.type === trackType)?.name ?? subType?.name ?? "No track name";
    const textWidth = ctx.measureText(label).width;

    const rectX = MARGIN;
    const rectY = currentY + MARGIN;
    const rectWidth = textWidth + 2 * PADDING_HORIZONTAL;
    const rectHeight = FONT_SIZE + 2 * PADDING_VERTICAL;

    if (height < rectHeight) {
      continue;
    }

    ctx.fillStyle = hoveredTackId === trackId ? colors.primaryMain : colors.textDefault;
    ctx.beginPath();
    ctx.roundRect(rectX, rectY, rectWidth, rectHeight, CORNER_RADIUS);
    ctx.fill();

    ctx.fillStyle = "white";
    ctx.fillText(label, rectX + rectWidth / 2, rectY + rectHeight / 2);
    currentY += height;
  }
  ctx.restore();
}
